<aux-drawer #drawer>
  <div class="actions-container">
    <a class="action" mat-raised-button color="primary" (click)="createNew()">Create </a>
  </div>
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    (selectedTabChange)="archivedOrNotChange($event)"
    [selectedIndex]="activeTabIndex$ | async"
  >
    <mat-tab label="{{ 'ADMINISTRATION.CUSTOM_FIELDS.NAME' | translate }}"></mat-tab>
    <mat-tab label="{{ 'ADMINISTRATION.CUSTOM_FIELDS.ARCHIVED' | translate }}"></mat-tab>
  </mat-tab-group>
  <ng-template *ngTemplateOutlet="mainFieldsView"></ng-template>
</aux-drawer>
<ng-template #mainFieldsView>
  <va-filtered-mat-table
    id="custom-field-table"
    [ngClass]="{
      'archived-table': viewingArchived$$ | async,
    }"
    [tableDataService]="tableService"
    [fullHeightTable]="true"
    (rowClick)="rowClicked($event)"
    [initEmptyStateTemplate]="initEmptyState"
  ></va-filtered-mat-table>
</ng-template>

<ng-template #fieldEditorPanel>
  <aux-app-auxiliary-data-panel
    #auxiliaryDataPanelComponent
    [drawer]="drawer"
    [createNewField]="creatingNewField$$ | async"
    [objectType]="objectType$$ | async"
    (objectTypeSelected)="selectObjectType($event)"
  ></aux-app-auxiliary-data-panel>
</ng-template>

<ng-template #initEmptyState>
  <glxy-empty-state class="empty-state-container">
    <div class="wistia_responsive_padding">
      <glxy-empty-state-hero>
        <div class="wistia_responsive_wrapper">
          <div class="wistia_embed wistia_async_3vkidhas6i videoFoam=true">&nbsp;</div>
        </div>
      </glxy-empty-state-hero>
      <glxy-empty-state-title class="empty-state-title">
        {{ 'ADMINISTRATION.CUSTOM_FIELDS.EMPTY_STATE_TITLE' | translate }}</glxy-empty-state-title
      >
      <p>
        {{ 'ADMINISTRATION.CUSTOM_FIELDS.EMPTY_STATE_DESCRIPTION' | translate }}
      </p>
      <glxy-empty-state-actions>
        <button mat-flat-button color="primary" (click)="createNew()">
          {{ 'ADMINISTRATION.CUSTOM_FIELDS.CREATE_LABEL' | translate }}
        </button>
        <a
          mat-stroked-button
          href="https://docs.vendasta.com/docs/administration/data-management/custom-fields"
          target="_blank"
          >{{ 'ADMINISTRATION.CUSTOM_FIELDS.EMPTY_STATE_LEARN_MORE' | translate }}</a
        >
      </glxy-empty-state-actions>
    </div>
  </glxy-empty-state>
</ng-template>
